export default defineAppConfig({
  ui: {
    colors: {
      primary: 'equator',
      neutral: 'midnight'
    },
    pageHero: {
      slots: {
        headline: 'font-display',
        title: 'font-semibold'
      }
    },
    pageSection: {
      slots: {
        headline: 'font-display',
        title: 'font-semibold'
      }
    },
    pageCTA: {
      slots: {
        headline: 'font-display',
        title: 'font-semibold'
      }
    }
  }
})
